import { myapiHost } from '@/conf/env'
import { getJSON, request } from '@/utils/request'
import { Account } from '@/types/account'

export type LoginValues = {
  account: string;
  password: string;
}

export type ChangePassword = {
  oldpass: string;
  newpass: string;
  snewpass: string;
}

export async function login(values: LoginValues) {
  return request<Account>({
    url: `${ myapiHost }/login`,
    method: 'POST',
    data: values,
    withCredentials: true,
  })
}

export async function get_back_account(phone: string) {
  return request<null>({
    url: `${ myapiHost }/getback/account/${ phone }`,
    method: 'GET',
    withCredentials: true,
  })
}

export async function change_password(values: ChangePassword) {
  return request<null>({
    url: `${ myapiHost }/change/password`,
    method: 'POST',
    data: values,
    withCredentials: true,
  })
}

export default {
  login,
  get_back_account,
  change_password,
}
